import { Spacing } from '@zoomit/primitives';
import type { DisplayModule, ModuleWithData } from '@zoomit/web-kit';
import { ModuleParser } from '@zoomit/web-kit';

type Props = {
  modules: (ModuleWithData | DisplayModule)[];
  modulesGap?: number;
};

const ModuleParserComposer = (props: Props) => {
  const { modules, modulesGap = Spacing.x12 } = props;

  return <ModuleParser modules={modules} modulesGap={modulesGap} />;
};

export default ModuleParserComposer;
